import { eventBus, EVENTS } from './EventBus.js';
import Utils from "./utils.js";

// eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {

$(document).on('click','.podcast-share',(e)=>{

  var container=$(e.currentTarget).closest('.blocco_podcast_audio');          ////container pagina podcast dettaglio

  if(container.length==0){
      container=$(e.currentTarget).closest('.ultimo_episodio');               ////container podcast programmi Tutti pazzi e Peggio più peggio home e pagina podcast
  }

  if(container.length==0){
      container=$(e.currentTarget).closest('.container_little_play_item');    ////container podcast su home RDS INFORMA
  }

  if(container.length==0){

      container=$(e.currentTarget).closest('.single-box-preferiti');          ////container condivisione UGC / vota un item

      const playEl=container.find('.podcast-share');

      const img=playEl.attr('data-cover');
      const title=playEl.attr('data-titolo');
      const slug=window.slug_game;

      const url = `${location.protocol}//${location.host}${slug}`;
      facebookShare({img: img, title: title, caption: 'x', url: url});

  } else{

      eventBus.emit(EVENTS.PODCAST_SHARE);

      const playEl=container.find('.podcast-play');

      const img=playEl.attr('data-cover');
      const title=playEl.attr('data-titolo');
      const slug=playEl.attr('data-slug');

      const url = `${location.protocol}//${location.host}${slug}`;
      facebookShare({img: img, title: title, caption: 'x', url: url});

  }

});

// });

eventBus.on(EVENTS.SHOW_LOADING, function(data) {
    Utils.showWaitingLoader();
});

eventBus.on(EVENTS.HIDE_LOADING, function(data) {
    Utils.hideWaitingLoader();
});

eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {

    const template = data.template;

    if (template == 'single_post') {
        console.log('instagram process post');
        window.instgrm.Embeds.process();
    }
    
    $(".voice_menu_to_click_mobile").removeClass("selected");
    $(".voice_menu_to_click").removeClass("selected");
    $(".secondary_menu").removeClass("selected");

    window.closeAllMenu();
    window.toggleHamMenu();
    var menu = window.menu;

    var menu_to_click = Object.values(menu).find(i => i.url==location.pathname|| i.elements.find(ii => ii.url==location.pathname) );

    var menu_id = "";

    if(!menu_to_click){

        var url = location.pathname.split("/")[1];
        var url2 = location.pathname.split("/")[2];
        if(url == "podcast" || url == "tutti-pazzi-per-rds" || url == "i-peggio-piu-peggio-di-rds" || url == "il-meglio-di-rds" || url == "podcast-video"){
            menu_id = "558808";
        }else if(url == "scopri" && url2 == "eventi-rds"){
            menu_id = "558810";
        }else if(url == "scopri" && url2 == "magazine"){
            menu_id = "558809";
        }else if(url == "conduttori"){
            menu_id = "558806";
        }else if(url == "classifiche"){
            menu_id = "558807";
        }else if(url == "home" || url == "homepage"){
            menu_id = "450499";
        }else if(url == "profilo" || url == "login"){
            menu_id = "profilo";
        } else if(url == "gioca"){
            menu_id = "gioca";
        } else if(url == "come-ascoltarci"){
            $(".secondary_menu[data-id='come_ascoltarci']").addClass("selected");

        }else if(url == "frequenze"){
            $(".secondary_menu[data-id='frequenze']").addClass("selected");

        }else if(url == "rds-social-tv"){
            $(".secondary_menu[data-id='socialtv']").addClass("selected");

        }

    } else{
        menu_id = menu_to_click["ID"];
    }
    $(".voice_menu_to_click_mobile[data-id='" + menu_id + "']").addClass("selected");
    $(".voice_menu_to_click[data-id='" + menu_id + "']").addClass("selected");


    ////reset tutti i paginatori al cambio pagina
    resetRootVariable();

});




function resetRootVariable(){

    var root_variable = Array.from(document.styleSheets)
        .filter(
            sheet =>
                sheet.href === null || sheet.href.startsWith(window.location.origin)
        )
        .reduce(
            (acc, sheet) =>
                (acc = [
                    ...acc,
                    ...Array.from(sheet.cssRules).reduce(
                        (def, rule) =>
                            (def =
                                rule.selectorText === ":root"
                                    ? [
                                        ...def,
                                        ...Array.from(rule.style).filter(name =>
                                            name.startsWith("--")
                                        )
                                    ]
                                    : def),
                        []
                    )
                ]),
            []
        );

    // console.log(root_variable);

    for (let i = 0; i < root_variable.length; i++) {
        if(root_variable[i].includes("paginator")){
            document.documentElement.style.setProperty(root_variable[i], '0');
        }
    }
}
